<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 16.381"
    aria-hidden="true"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="2"
    >
      <path d="M7.5 1v14.381" />
      <path d="M14 7.677H1" data-name="Line Copy" />
    </g>
  </svg>
</template>
